import React from 'react'
import {
    Drawer,
    ModalProps,
    DrawerBody,
    DrawerOverlay,
    DrawerHeader,
    DrawerContent,
} from '@chakra-ui/react'
import { IconButton } from '@chakra-ui/react'
import { ChevronLeftIcon } from '@chakra-ui/icons'
import { useBreakpointValue } from '@chakra-ui/react'

import ChangeLogView from '~components/shared/change-log/change-log-view'

interface Props extends Omit<ModalProps, 'children'> {
    entityId: string
    loading?: boolean
}

export default function ChangeLogDrawer({
    entityId,
    loading,
    ...props
}: Props) {
    const modalSize = useBreakpointValue({ base: 'full', md: 'lg' })

    return (
        <Drawer
            placement="right"
            size={modalSize}
            blockScrollOnMount={false}
            {...props}
        >
            <DrawerOverlay />
            <DrawerContent>
                <DrawerHeader
                    pb={4}
                    shadow="blue.md"
                    display="flex"
                    justifyContent="space-between"
                >
                    <IconButton
                        size="sm"
                        icon={<ChevronLeftIcon fontSize="xl" />}
                        variant="outline"
                        rounded="full"
                        aria-label="Close Modal"
                        onClick={props.onClose}
                    />
                </DrawerHeader>
                <DrawerBody px={{ base: 2, md: 8 }} py={{ base: 4, md: 6 }}>
                    <ChangeLogView entityId={entityId} />
                </DrawerBody>
            </DrawerContent>
        </Drawer>
    )
}
